import React from "react";

const SendIcon = () => {
  return (
    <svg
      width="12"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ minWidth: "12px" }}
      className="inline-block"
    >
      <path
        d="M12.25 2.25L1.16663 6.37358L6.99996 7.50233L8.45975 13.3333L12.25 2.25Z"
        stroke="black"
        strokeWidth="1.16667"
        strokeLinejoin="round"
      />
      <path
        d="M7.00232 7.50233L8.65228 5.85266"
        stroke="black"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SendIcon;
